<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('tag.update_title') }}</span>
            <span v-else>{{ $t('tag.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('tag.name') }}</label>
          <b-form-input type="text" :placeholder="$t('tag.name_placeholder')"
            :class="{ 'is-invalid' : fErr('name') }"
            v-model="entity.name"/>
        </b-form-group>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'Tags' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
        };
      },
    },
  },
  components: {
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
  },
  methods: {
    getForUpdate: Services.tags.editData,
    getForCreate: Services.tags.createData,
    pushUpdate: Services.tags.update,
    pushCreate: Services.tags.create,
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.tag : { ...this.entity, ...data.data.tag };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          this.$router.push({ name: 'Tags' });

          // After successful create
          // if (this.$can('edit', 'tags')) {
          // this.$router.push({ name: 'TagUpdate', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped>
</style>
